import React from 'react';
import { ButtonsSelectInputLayoutProps, ButtonsSelectInputLayoutType } from 'framework/form';
import { getPrimitiveOptionValue } from 'framework/form/input/dropdownHelper';
import DoneIcon from '@mui/icons-material/DoneOutlined';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import { styled } from '@mui/material/styles';

const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }: any) => ({
  marginBottom: '24px',
  marginTop: '8px',
  '& .MuiToggleButtonGroup-grouped:not(:first-of-type)': {
    borderLeftColor: theme.vars.palette.border.strong,
  },
  '& .MuiToggleButton-root': {
    '&.Mui-selected': {
      pointerEvents: 'none',
      color: theme.vars.palette.primary.dark,
      background: theme.vars.palette.background.primary,
      paddingLeft: '13px',
      paddingRight: '15px',
    },
    borderColor: theme.vars.palette.border.strong,
    textTransform: 'none',
    color: theme.vars.palette.text.primary,
    lineHeight: theme.typography.pxToRem(16),
    fontWeight: 500,
    padding: '10px 20px',
  },
}));

/**
 * Layout that displays button (and buttons have keys) and only one button can be selected.
 * @param options - options
 * @param value - selected value
 * @param createOnChangeCallback - function that accept key and return callback
 * (this callback will be called without parameters when user click on the button)
 * @param disabled - boolean value for disabling input if need
 */
const ButtonsSelectInputLayout: ButtonsSelectInputLayoutType = ({
  options = [],
  value,
  createOnChangeCallback,
  disabled,
}: ButtonsSelectInputLayoutProps) => {
  return (
    <StyledToggleButtonGroup color="secondary" value={value} exclusive>
      {options.map(item => {
        const { label, value: rawKey } = item;
        const key = getPrimitiveOptionValue(rawKey);

        return (
          <ToggleButton
            data-testid={key}
            key={key}
            value={key}
            aria-label={key.toString()}
            onClick={createOnChangeCallback(key)}
            disabled={disabled}
          >
            {key === value && <DoneIcon sx={{ marginRight: '10px', width: '18px', height: '18px' }} />}
            {label}
          </ToggleButton>
        );
      })}
    </StyledToggleButtonGroup>
  );
};

export default ButtonsSelectInputLayout;
